
module.exports = {"attributes":{"width":"10","height":"24","viewBox":"0 0 10 24","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M8.19096 0.412014L9.80796 1.58801L2.23596 12L9.80896 22.412L8.19196 23.588L0.19196 12.588C-0.0630397 12.237 -0.0630397 11.763 0.19196 11.412L8.19096 0.412014Z\"/>"}
var desvg = require('@kossnocorp/desvg/preact')
module.exports = desvg(module.exports)
